/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { projectSettingsServicedeskNotificationsNotificationEmailRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskNotificationsNotificationEmailRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { LazyProjectSettingsNotificationEmail } from './ui/notification-email/index.tsx';
import { ServiceDeskNotificationEmailNextGenRedirect } from './ui/service-desk-notification-email-next-gen-redirect/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const projectSettingsServicedeskNotificationsNotificationEmailRouteEntry: Route =
	createEntry(
		projectSettingsServicedeskNotificationsNotificationEmailRoute,

		() => ({
			group: 'project-settings-servicedesk',
			// eslint-disable-next-line no-restricted-syntax
			component: ServiceDeskNotificationEmailNextGenRedirect,
			layout: serviceProjectLayout,

			navigation: {
				menuId: MenuIdProjects,
				sidebarId: SidebarIdProjectSettings,
			},

			resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],
			forPaint: [LazyProjectSettingsNotificationEmail],

			bifrost: {
				bifrostGroup: 'shell-only',
			},
		}),
	);
